import React from 'react';

interface MetaStatsProps {
  value: string | number;
  name: string;
}

const MetaStats = ({ value, name }: MetaStatsProps) => (
  <div className="prose-title-h1">
    <div data-testid={name}>{value}</div>
    <div className="prose-body-sm-reg">{name}</div>
  </div>
);

export default MetaStats;
